import { Component, OnInit } from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard-item-message',
  templateUrl: './dashboard-item-message.component.html',
  styleUrls: ['./dashboard-item-message.component.css']
})

export class DashboardItemMessageComponent implements OnInit {

  constructor() {}

  public arrayMessage: any;

  ngOnInit(): void {
    this.arrayMessage = {
      global: { mustRead: 120 },
      thead: ['information', 'date', 'type'],
      tbody: [
        {
          information: 'tutu', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'error'
        },
        {
          information: 'toto', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'debug'
        },
        {
          information: 'tata', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'fixed'
        },
        {
          information: 'tutu', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'error'
        },
        {
          information: 'toto', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'debug'
        },
        {
          information: 'tata', date: 'Fri Jan 20 2012 11:51:36 GMT+0500', type: 'fixed'
        }
      ]
    };
  }

}
